const BandType = {
    SET_BAND:'SET_BAND',
    SET_BAND_LIST_TO_VIEW:'SET_BAND_LIST_TO_VIEW'
}
export default BandType;